const t = "data-menu-item";
export {
  t as MENU_ITEM
};
